import {randomString} from "../helpers/strings";

export default function SvgComparison(props) {
    return (
        <svg {...props} viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.4685 0.082465C21.9871 -0.129593 21.4256 0.082465 21.2049 0.545138C20.9843 1.00781 21.2049 1.5476 21.6863 1.75965C22.1676 1.97171 22.7292 1.75965 22.9498 1.29698C23.1705 0.834309 22.9498 0.294523 22.4685 0.082465Z" fill="#010202"/>
            <path d="M29.0667 6.36633H29.0467L17.0762 6.36633V8.19711L27.1413 8.19711L20.9038 14.2098L22.2476 15.5009L30.4105 7.65751L29.0667 6.36633Z" fill="#010202"/>
            <path opacity="0.6" d="M21.3633 1.52732L22.7071 0.236145L30.4488 7.6556L29.085 8.94678L21.3633 1.52732Z" fill="url(#paint0_linear_3336_553)"/>
            <path d="M8.05886 0.082465C8.54021 -0.129593 9.10179 0.082465 9.32241 0.545138C9.54303 1.00781 9.32241 1.5476 8.84106 1.75965C8.3597 1.97171 7.79812 1.75965 7.5775 1.29698C7.35688 0.834309 7.5775 0.294523 8.05886 0.082465Z" fill="#010202"/>
            <path d="M1.46063 6.36633H1.48069L12.4512 6.36633V8.19711L3.38604 8.19711L9.62356 14.2098L8.27979 15.5009L0.116856 7.65751L1.46063 6.36633Z" fill="#010202"/>
            <path opacity="0.6" d="M9.16211 1.52732L7.81833 0.236145L0.0765829 7.6556L1.44041 8.94678L9.16211 1.52732Z" fill="url(#paint1_linear_3336_553)"/>
            <defs>
                <linearGradient id="paint0_linear_3336_553" x1="25.8992" y1="0.22701" x2="25.8992" y2="8.95485" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0158937" stopColor="#010202"/>
                    <stop offset="1" stopColor="#010202" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_3336_553" x1="4.62617" y1="0.22701" x2="4.62617" y2="8.95485" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0158937" stopColor="#010202"/>
                    <stop offset="1" stopColor="#010202" stopOpacity="0"/>
                </linearGradient>
            </defs>
        </svg>

    )
}